/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./section.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./section.component";
var styles_SectionComponent = [i0.styles];
var RenderType_SectionComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SectionComponent, data: {} });
export { RenderType_SectionComponent as RenderType_SectionComponent };
export function View_SectionComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_SectionComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-section", [], null, null, null, View_SectionComponent_0, RenderType_SectionComponent)), i1.ɵdid(1, 114688, null, 0, i2.SectionComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SectionComponentNgFactory = i1.ɵccf("cc-section", i2.SectionComponent, View_SectionComponent_Host_0, {}, {}, ["*"]);
export { SectionComponentNgFactory as SectionComponentNgFactory };
